export default __webpack_public_path__ + "cff25f26300be44275c37d11051ac0f9.svg";